import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useUsers } from "@/hooks/useUsers";

const NONE = "__none__";

/** Inline user picker for "who owns this". */
export function OwnerPicker({ value, onChange, className }: {
  value: string | null | undefined;
  onChange: (userId: string | null) => void;
  className?: string;
}) {
  const { data: users = [] } = useUsers();
  return (
    <Select value={value ?? NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
      <SelectTrigger className={className ?? "h-7 text-xs w-[150px]"}><SelectValue placeholder="Owner" /></SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>Unassigned</SelectItem>
        {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name ?? u.email}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
